var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"potocal-page"},[_c('div',{staticClass:"paragraph ql-editor",domProps:{"innerHTML":_vm._s(_vm.content)}}),_c('p',{staticClass:"empty"},[_vm._v(_vm._s(_vm.errMessage))])])}
var staticRenderFns = []

export { render, staticRenderFns }